<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>单位信息管理</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>打卡记录</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <div style="display:flex;align-items:center;margin-right:20px">
                <!-- <span style="margin-right:10px">日期:</span>
                <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker> -->
              </div>
              <!-- <div style="display:flex;align-items:center;margin-right:20px">
                 <span style="margin-right:10px">进出方向:</span>
                  <el-select
                   v-model="search.status"
                   clearable
                   filterable
                   placeholder="请选择状态"
                   class="select"
                   @change="search"
                   style="width:200px"
                 >
                   <el-option  v-for="item in attendType" :key="item.id" :label="item.label" :value="item.value"></el-option>
                 </el-select>
              </div> -->
              <div style="display:flex;align-items:center;">
                <el-input
                  v-model="search.personName"
                  placeholder="请输入单位名称"
                  clearable
                >
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
              
            </div>
            <el-button
              type="primary"
              plain
              style="display:flex;align-items:center"
              @click="addUnit"
            >添加</el-button>
             <!-- <el-tooltip class="item" effect="dark" content="导出" placement="top-end" v-if="isMenuExit('pro:record:export')">
                <img  class="icon_hover"  @click="exportWorker" src="../../assets/image/export.png" alt="" srcset="">
             </el-tooltip> -->
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              @filter-change="filterTag"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ (currentPage - 1) * pageSize + scope.$index + 1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="单位信息名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.unitName }}</span>
                </template>
              </el-table-column>       
              <el-table-column label="创建人">
                <template slot-scope="scope">
                  <span>{{ scope.row.createBy }}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="createDate" >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>             
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary"  @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                  <el-button size="mini" type="danger"  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini" @click="personInfo(scope.$index, scope.row)">岗位信息</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
      <!-- 新增窗口 -->
      <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      width="500px"
      append-to-body
      class="add-form"
    >
      <el-form :model="addForm" :rules="rules" label-width="120px" ref="addForm">
        <el-form-item label="单位名称">
          <el-input v-model="addForm.unitName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        projectId:'',
        unitName: '',
      },
      listData: [], //表格数据
      dataText: '数据加载中...',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      attendType: [],
      addForm:{
        unitId:'',
        unitName:'',
      },
      dialogTitle:'',
      addFormVisible:false,
      
      // types:[],//进出类型
    }
  },
  created() {
      var role = util.session.get('roleId')
      this.search.groupId = util.session.get('groupId')
      if(role==4){
        this.search.groupType =2
      }else if(role==5){
        this.search.groupType =1
      }
  },
  mounted() {
    //this.search.projectId = util.session.get('groupId')
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // console.log(this.search.projectId)
    this.search.groupId = util.session.get('groupId')
    this.getDict() //获取考勤
    //this.getData()
  },
  methods: {
    //
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList||[]
            for(var i=0;i<list.length;i++){
              list[i].text = list[i].label
            }
            that.attendType = list
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    // 搜索数据
    doFilter() {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      myHttp.findSysUnitListPage(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)

            }
            that.listData = list
            that.totalItems = resp.data.data.total || 0
            //that.getTypeName()
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    exportWorker() {
      var token = util.session.get('token')
      window.open(
        myHttp.exportAttendList +
          '?projectId=' +
          this.search.projectId +
          '&personName=' +
          this.search.personName +
          '&date=' +
          this.search.date +
          '&accessToken=' +
          token
      )
    },
    //删除
    handleDelete(index,row){
          var that = this;
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              myHttp.deleteSysUnit({
                unitId:row.unitId
              }).then(function(resp){
                  if(resp.data.code=="200"){
                      that.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                      that.getData();
                  }else{
                      that.$message.error(resp.data.msg);
                  }
              },function(){});
           }).catch(err => {          
          })
      },
    // watchInput(e) {
    //   this.search.personName = e
    //   this.getData()
    // }
    personInfo(index,row){
        var port = util.session.get('roleId')
        if(port=='5'){
            this.$router.push({name: 'post',params: { unitId: row.unitId,unitName:row.unitName }})
        }else if(port=='4'){
          this.$router.push({name: 'postPro',params: { unitId: row.unitId,unitName:row.unitName }})

        }
        // else if(port=='5'||port=='3'){
        //      this.$router.push({name: 'workerInfoCom',params: { id: row.personId }})
        //  }  
    
    },
    // 添加单位
    addUnit(){
      var that = this
      this.addFormVisible = true
      this.addForm.unitId = ''
      this.addForm.unitName = ''
      this.dialogTitle = '添加'

    },
    // 修改
    handleEdit(index,row){
          this.addFormVisible = true
          this.dialogTitle = '修改'
          this.addForm.unitId  = row.unitId
          this.addForm.unitName = row.unitName
      },
     //保存
     sumbitAddRow(formName){
      var that = this;
      this.$refs[formName].validate((valid) => {
          if (valid) {
            that.addForm.groupId = this.search.groupId
            that.addForm.groupType = this.search.groupType
            // that.addForm.roleIds = that.addForm.list.join(',');
            if(that.addForm.unitId==''){
              myHttp.addSysUnit(that.addForm).then(function(resp){
                if(resp.data.code=="200"){
                  that.$message.success('添加单位成功');
                  that.addFormVisible = false;
                  that.getData();
                }else{
                  that.$message.error(resp.data.msg);
                }
              });
            }else{
              // that.addForm.roleIds = that.addForm.list.join(',');
              myHttp.editSysUnit(that.addForm).then(function(resp){
                if(resp.data.code=="200"){
                  that.$message.success('修改单位成功');
                  that.addFormVisible = false;
                  that.getData();
                }else{
                  that.$message.error(resp.data.msg);
                }
              });
            }
          }
      });
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },

    filterTag(filters) {
        // console.log(filters)
        this.search.status = filters.aStatus[0]
        this.getData()
    }
    
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-input-group--append .el-input__inner{
      width: 200px;
    }
</style>